export const SUBSCRIBER_DOWNLOAD_TYPES = {
  HTML: 'html',
  PDF: 'pdf',
};
